import { RouteObject } from "react-router-dom";
import { ErrorPage } from "../app/error";
import { SalesAuthLayout } from "../components/layout/salesAuthLayout";
import { SalesSignupPage } from "../app/_sales/auth/signup";
import { SalesLoginPage } from "../app/_sales/auth/login";
import { ForgotPasswordPage } from "../app/auth/forgotPassword";
import { PageNotFound } from "../app/404";
import { AppLayout } from "../components/layout/appLayout";
import { LegalPage } from "../app/legal";
import { SalesDashboardPage } from "../app/_sales/dashboard";
import { SalesAppLayout } from "../components/layout/salesAppLayout";
import { SalesProtected } from "../components/layout/protected";
import { UserSalesPage } from "../app/_sales/dashboard/userSales";
import { SingleOrganizerPage } from "../app/_sales/dashboard/singleOrganizer";
import { InviteProtectedLayout } from "../components/layout/inviteProtectedLayout";
import { ExpiredInvite } from "../app/_sales/auth/expiredInvite";

export const salesRouter: RouteObject[] = [
  {
    path: "/",
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        path: "",
        element: (
          <SalesAuthLayout>
            <SalesLoginPage />
          </SalesAuthLayout>
        ),
      },
      {
        path: "login",
        element: (
          <SalesAuthLayout>
            <SalesLoginPage />
          </SalesAuthLayout>
        ),
      },
      {
        path: "/signup",
        element: (
          <SalesAuthLayout>
            <InviteProtectedLayout>
              <SalesSignupPage />
            </InviteProtectedLayout>
          </SalesAuthLayout>
        ),
      },
      {
        path: "forgot-password",
        element: (
          <SalesAuthLayout>
            <ForgotPasswordPage />
          </SalesAuthLayout>
        ),
      },
      {
        path: "dashboard",
        element: (
          <SalesAppLayout>
            <SalesProtected>
              <SalesDashboardPage />
            </SalesProtected>
          </SalesAppLayout>
        ),
      },
      {
        path: "dashboard/sales/users/:id/:slug",
        element: (
          <SalesAppLayout>
            <SalesProtected>
              <UserSalesPage />
            </SalesProtected>
          </SalesAppLayout>
        ),
      },
      {
        path: "dashboard/organizer/:id",
        element: (
          <SalesAppLayout>
            <SalesProtected>
              <SingleOrganizerPage />
            </SalesProtected>
          </SalesAppLayout>
        ),
      },
      {
        path: "legal/:doc",
        element: (
          <AppLayout>
            <LegalPage />
          </AppLayout>
        ),
      },
      {
        path: "404",
        element: (
          <SalesAuthLayout>
            <PageNotFound />
          </SalesAuthLayout>
        ),
      },
      {
        path: "/expired/invite",
        element: (
          <SalesAuthLayout>
            <ExpiredInvite />
          </SalesAuthLayout>
        ),
      },
    ],
  },
  {
    path: "*",
    element: (
      <SalesAuthLayout>
        <PageNotFound />
      </SalesAuthLayout>
    ),
  },
];
